import React, { useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux'

import { clearState, setUdn} from "../../../redux/actions/generalActions/mainActions";
import { showLoader } from "../../../components/loader/loader";
import XtorageCampaignsList from "./_list";
import SearchXt  from "../../../components/searchxt/searchXt";

const XtorageCampaigns = props => {
    const { viewMode, loading } = props.mainProps

    useEffect(() => {
        return () => {
            props.clearState();
        }
    }, []);

    return (
        <>
            { loading ? showLoader() : null}
            <h2 className="pb-2 font-bold ">Campañas</h2>
            <SearchXt />
            <Row>
                <Col md="12">
                    {(
                        function() {
                            switch (viewMode) {
                                case "LIST" :
                                    return <XtorageCampaignsList />
                                default:
                                    return null;
                            }
                        })()}
                </Col>
            </Row>
        </>
    );
}

const mapStateToProps = state => ({
    mainProps : state.mainProps
});

const mapActionsToProps = ({
    clearState,
    setUdn,
});

export default connect(mapStateToProps, mapActionsToProps)(XtorageCampaigns)
